export const sendAnalyticsEvent = (event: string | any) =>
    typeof event === 'string' ? window?.dataLayer?.push({ event }) : window?.dataLayer?.push(event);
